import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Setting } from '../common/Setting';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root',
})
export class SettingService extends ApiServiceBase {
  protected readonly path = 'setting';

  createOrUpdateMultiple(settings: Setting[]): Observable<any> {
    return this.http
      .post(this.getUrl() + '/batchcreateorupdate', settings);
  }

  getByReference(refId: string, refType: string): Observable<Setting[]> {
    return this.http
      .get<Setting[]>(this.getUrl(), { params: { entityType: refType, referenceId: refId } });
  }
}
